import { useQuery, UseQueryOptions } from 'react-query';
import { useService } from '@core/inversify-react';

import { GetBranchPartnerByIdRepoType, IGetBranchPartnerByIdRepo } from '../repos';
import { IBranchPartnerById } from '../interfaces';

export const useBranchPartnerById = (id?: string, options?: UseQueryOptions<IBranchPartnerById, Error, IBranchPartnerById, string[]>) => {
  const getCourierByIdRepo = useService<IGetBranchPartnerByIdRepo>(GetBranchPartnerByIdRepoType);

  return useQuery<IBranchPartnerById, Error, IBranchPartnerById, string[]>(
    ['branch-partner', id || ''],
    async ({ queryKey }) => {
      const [, id] = queryKey;
      const result = await getCourierByIdRepo.execute(id);

      if (result.status === 200) {
        return result.response;
      } else {
        throw new Error(result.response);
      }
    },
    options,
  );
};
